// extracted by mini-css-extract-plugin
export default {"copyright":"copyright_copyright__X1QAV"};